import {React, useState, useEffect} from 'react';
import { useDispatch } from 'react-redux';
import { updateTableActions } from '../../store/update-table-slice';
import {Box, Paper, Grid, Stack, FormControl, InputLabel, MenuItem, Typography, Select, FormHelperText, TextField, Button, } from '@mui/material';
import {PersonAddAlt1} from '@mui/icons-material';
import axios from 'axios';
import { getMonthList } from '../../services/monthList';
import { getYearList } from '../../services/yearList';
import Notification from '../Notification';
import { useNavigate } from 'react-router-dom';


const monthOptions = getMonthList();
const yearOptions = getYearList();

const initialFValues = {
    id: 0,
    deductionType: '',
    month: '',
    year: '',
    amount: '',
}

const RequiredLabel = ({ label }) => (
  <span>
    {label}
    <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
  </span>
);

const AddEmpDeductionComponent = (props) => {

  const [deductionTypes, setDeductionTypes] = useState([]);
  // Fixed: Initialize state with the initialFValues object
  const [values, setValues] = useState(initialFValues);
  const [errors, setErrors] = useState({});
  const [notify, setNotify] = useState({isOpen: false, message: '', type: ''});
  const navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(() => {
      if (notify.isOpen && notify.type === 'success') {
        // Close the modal after a short delay to show the notification
        const timer = setTimeout(() => {
          // Call the parent's function to close the modal
          if (props.onCloseModal) {
            props.onCloseModal();
          }
        }, 100);
        
        return () => clearTimeout(timer);
      }
    }, [notify, props.onCloseModal]);

  useEffect(() => {
    async function getDeductionTypes() {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/employee-master/get-deduction-types`);
        setDeductionTypes(response.data);

      } catch (e) {
        if(e.response.status === 401) {
          setNotify({
            isOpen: true,
            message: 'Session Expired!',
            type: 'error'
          });
          setTimeout(() => {
            navigate('/');
          },1000);
        }
      }
    }
    getDeductionTypes();
  }, []);


    const validate = () => {
        let temp = {};
        // Validate that amount is not empty and is a numeric value.
        temp.amount = values.amount ? (isNaN(parseFloat(values.amount)) ? "Amount must be a numeric value." : "") : "This field is required.";
        // Use strict inequality check.
        temp.deductionType = values.deductionType.length !== 0 ? "" : "This field is required!";

        setErrors({
            ...temp
        });

        // Return true only if all validation checks pass.
        return Object.values(temp).every(x => x === "");       
    }

    const resetForm = () => {
        setValues(initialFValues);
        setErrors({});       
    }

    function handleInputChange(event) {
        const {name, value} = event.target;
        setValues({
            ...values,
            [name]: value      //overwrite name property.
        });
        if (errors[name]) {
          setErrors({
              ...errors,
              [name]: ''
          });
      }
    }

    const handleSubmit = (e) => {
      e.preventDefault();
      // Crucial fix: Only proceed with submission if validation passes.
      if(validate()){
          let API_URL = '';
          if(props.fetch_id === 9999) {
            API_URL = `${process.env.REACT_APP_API_BASE_URL}/employee-master/add-deduction/` + props.employeeID;
          } else {
            API_URL =`${process.env.REACT_APP_API_BASE_URL}/employee-master/add-deduction/` + props.fetch_id;
          }
          axios.post(API_URL, values)
          .then((response) => {
            if(response.status === 200) {
              setNotify({
                isOpen: true,
                message: 'Successfully added',
                type: 'success'
              });
              dispatch(updateTableActions.startUpdateEmpDeductionComponents());
            }
          })
          .catch((e) => {
            if(e.response.status === 401) {
              setNotify({
                isOpen: true,
                message: 'Session Expired!',
                type: 'error'
              });
              setTimeout(() => {
                navigate('/');
              },1000);
            }
        });
      }
    }
    
    return(
        <Box sx={{display: "flex" ,justifyContent: "center", margin: "10px",marginTop: "-30px", padding: "50px", fontWeight: "500px"}}>
          <Paper elevation={2} sx={{width: "500px"}}>
            <Grid className="form-title" container spacing={2}>
              <Grid item> <Typography variant="h5" sx={{textAlign: "center", margin: 5}}>ADD EMPLOYEE DEDUCTION COMPONENT</Typography> </Grid>
              <Grid item> <PersonAddAlt1 sx={{marginTop: "-70px",width: 45, height: 45}}/> </Grid>
            </Grid>
            <form className="classes.root" autoComplete="off" onSubmit={handleSubmit}>
    
              <Stack spacing={2} sx={{margin: "30px"}}>


              <FormControl
                  variant="outlined"
                  
                  {...(errors.deductionType && {error:true} )}>
                    <InputLabel> <RequiredLabel label="Deduction Type" /> </InputLabel>
                    <Select
                      label="Deduction Type"
                      name="deductionType"
                      size="small"
                      value={values.deductionType}
                      onChange={handleInputChange}
                    >
                      <MenuItem value="">None</MenuItem>
                        {
                          deductionTypes.map(
                            item => (<MenuItem key={item.deduction_earning_id} value={item.deduction_earning_id}>{item.deduction_earning_type}</MenuItem>)
                          )
                        }
    
                    </Select>
                    { errors.deductionType && <FormHelperText>{errors.deductionType}</FormHelperText>}
                </FormControl>

                <FormControl
                  variant="outlined"
                  {...(errors.month && {error:true} )}>
                    <InputLabel>Month</InputLabel>
                    <Select
                      label="Month"
                      name="month"
                      size="small"
                      value={values.month}
                      onChange={handleInputChange}
                    >
                      <MenuItem value="">None</MenuItem>
                        {
                          monthOptions.map(
                            item => (<MenuItem key={item.id} value={item.title}>{item.title}</MenuItem>)
                          )
                        }
    
                    </Select>
                    { errors.month && <FormHelperText>{errors.month}</FormHelperText>}
                </FormControl>

                <FormControl
                  variant="outlined"
                  {...(errors.year && {error:true} )}>
                    <InputLabel>Year</InputLabel>
                    <Select
                      label="Year"
                      name="year"
                      size="small"
                      value={values.year}
                      onChange={handleInputChange}
                    >
                      <MenuItem value="">None</MenuItem>
                        {
                          yearOptions.map(
                            item => (<MenuItem key={item.id} value={item.title}>{item.title}</MenuItem>)
                          )
                        }
    
                    </Select>
                    { errors.year && <FormHelperText>{errors.year}</FormHelperText>}
                </FormControl>

                <TextField
                  variant="outlined"
                  
                  name="amount"
                  label={<RequiredLabel label="Amount" />}
                  size="small"
                  value={values.amount}
                  onChange={handleInputChange}
                  {...(errors.amount && {error:true, helperText: errors.amount} )}
                />               
    
                <Grid container className="form-btn-container">
                  <Grid item>
                  <Button variant="contained" disableElevation color="error" type="button" onClick={resetForm}>Reset</Button>
                  </Grid>
                  <Grid item>
                  <Button variant="contained" disableElevation color="success" type="submit">Submit</Button>
                  </Grid>
                </Grid>
    
                </Stack>
            </form>             
    
          </Paper>
          <Notification
            notify={notify}
            setNotify={setNotify} />
        </Box>
      )
}

export default AddEmpDeductionComponent;
